const SUPPORTED_AUDIO_EXTENSIONS = [
  ".mp3",
  ".wav",
  ".ogg",
  ".flac",
  ".aac",
  ".aiff",
  ".aif",
  ".m4a",
  ".wma",
  ".opus",
];

const SUPPORTED_AUDIO_MIME_TYPES = [
  "audio/mpeg",
  "audio/mp3",
  "audio/wav",
  "audio/x-wav",
  "audio/wave",
  "audio/ogg",
  "audio/flac",
  "audio/aac",
  "audio/aiff",
  "audio/x-aiff",
  "audio/mp4",
  "audio/x-m4a",
  "audio/wma",
  "audio/opus",
];

export const AUDIO_FILE_ACCEPT = [
  ...SUPPORTED_AUDIO_EXTENSIONS,
  ...SUPPORTED_AUDIO_MIME_TYPES,
].join(",");

export function isSupportedAudioFile(file) {
  const extension = file.name.toLowerCase().match(/\.[^.]+$/)?.[0] || "";
  if (extension === ".webm") {
    return false;
  }
  if (SUPPORTED_AUDIO_EXTENSIONS.includes(extension)) {
    return true;
  }
  if (file.type) {
    if (file.type.includes("webm")) {
      return false;
    }
    return SUPPORTED_AUDIO_MIME_TYPES.includes(file.type);
  }
  return false;
}

export function getUnsupportedFileMessage(file) {
  return `「${file.name}」は対応していない形式です。MP3 / WAV / OGG / FLAC / AAC / AIFF などの音声ファイルを選んでください。`;
}
